import { render, staticRenderFns } from "./ProductEssentialItem.vue?vue&type=template&id=02dd50d4&scoped=true&"
import script from "./ProductEssentialItem.vue?vue&type=script&lang=js&"
export * from "./ProductEssentialItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductEssentialItem.vue?vue&type=style&index=0&id=02dd50d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd50d4",
  null
  
)

export default component.exports